import cn from 'classnames';
import { useEffect, useRef } from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { Loader } from '@src/library/components/common';
import * as st from './styles.module.scss';

interface Props {
  hasMore?: boolean;
  loadMore: () => void;
  loading: boolean;
  children: React.ReactNode;
  className?: string;
}

export const InfinityList = ({ hasMore, loadMore, loading, children, className = '' }: Props) => {
  const loaderRef = useRef<HTMLDivElement | null>(null);

  const [sentryRef] = useInfiniteScroll({
    loading,
    hasNextPage: hasMore || false,
    onLoadMore: loadMore,
    rootMargin: '0px 0px 100px 0px',
  });

  useEffect(() => {
    if (loaderRef.current) {
      sentryRef(loaderRef.current);
    }
  }, [sentryRef]);

  return (
    <section id="infiniteList" className={cn(st.list, className)}>
      {children}
      {loading && <Loader className={st.loader} />}
      <div ref={loaderRef} />
    </section>
  );
};
